// extracted by mini-css-extract-plugin
module.exports = {"toastify":"styles_toastify__3jgW3","icon":"styles_icon__3nYYj","title":"styles_title__1QlDU","message":"styles_message__3HQAY"};